export const de = {
    meta: {
        homeDescription: 'Luxuriöse Ferienvillen mit und ohne Pool, Ferienhäuser und Ferienwohnungen in Zarzis und auf Djerba. Unverbindlich anfragen, persönlich betreut aus Tunesien.',
        accommodationsTitle: 'Unterkünfte',
        accommodationsDescription: 'Villen mit und ohne Swimmingpool, Ferienhäuser und Ferienwohnungen in Zarzis und auf Djerba. Jetzt Ihre Unterkunft in Tunesien finden.',
        bookingTitle: 'Buchungsanfrage',
        bookingDescription: 'Senden Sie uns Ihre unverbindliche Buchungsanfrage für eine Villa, ein Ferienhaus oder eine Ferienwohnung in Tunesien.',
        contactTitle: 'Kontakt',
        contactDescription: 'Kontakt zu URLAUB DE LUXE TUNESIEN in El Mouensa, Zarzis. Fragen, Beratung und Buchungsanfragen.',
        loginTitle: 'Anmelden',
        registerTitle: 'Registrieren',
        verifyTitle: 'E-Mail bestätigen',
        forgotTitle: 'Passwort vergessen',
        privacyTitle: 'Datenschutz',
        imprintTitle: 'Impressum',
        accountTitle: 'Mein Kundenkonto'
    },
    common: {
        brandLine: 'Ferienvillen und Ferienwohnungen in Tunesien',
        save: 'Speichern',
        saving: 'Wird gespeichert …',
        cancel: 'Abbrechen',
        back: 'Zurück',
        send: 'Senden',
        sending: 'Wird gesendet …',
        close: 'Schließen',
        optional: 'optional',
        perNight: 'pro Nacht',
        from: 'ab',
        onRequest: 'Preis auf Anfrage',
        guestsUpTo: 'bis {count} Gäste',
        bedrooms: '{count} Schlafzimmer',
        bathrooms: '{count} Bäder',
        sqm: '{count} m²',
        privatePool: 'Privater Pool',
        withPool: 'Mit Pool',
        withoutPool: 'Ohne Pool',
        viewDetails: 'Details ansehen',
        requestNow: 'Jetzt anfragen',
        download: 'Herunterladen',
        open: 'Öffnen',
        yes: 'Ja',
        no: 'Nein',
        nightOne: '1 Nacht',
        nightOther: '{count} Nächte',
        adultOne: '1 Erwachsener',
        adultOther: '{count} Erwachsene',
        childOne: '1 Kind',
        childOther: '{count} Kinder',
        accommodationOne: '1 Unterkunft',
        accommodationOther: '{count} Unterkünfte',
        choose: 'Bitte wählen',
        commonCountries: 'Häufig gewählt',
        allCountries: 'Alle Länder'
    },
    nav: {
        home: 'Startseite',
        accommodations: 'Unterkünfte',
        about: 'Über uns',
        booking: 'Buchungsanfrage',
        contact: 'Kontakt',
        login: 'Anmelden',
        register: 'Registrieren',
        account: 'Mein Konto',
        logout: 'Abmelden',
        openMenu: 'Menü öffnen',
        closeMenu: 'Menü schließen',
        language: 'Sprache wählen',
        skip: 'Zum Inhalt springen'
    },
    types: {
        villa: 'Villa',
        house: 'Ferienhaus',
        apartment: 'Ferienwohnung'
    },
    amenities: {
        pool: 'Privater Swimmingpool',
        shared_pool: 'Gemeinschaftspool',
        sea_view: 'Meerblick',
        beach_access: 'Strandnähe',
        wifi: 'WLAN',
        ac: 'Klimaanlage',
        heating: 'Heizung',
        kitchen: 'Voll ausgestattete Küche',
        washing_machine: 'Waschmaschine',
        tv: 'Smart-TV',
        parking: 'Privatparkplatz',
        garden: 'Garten',
        terrace: 'Terrasse',
        rooftop: 'Dachterrasse',
        courtyard: 'Innenhof',
        bbq: 'Grill',
        housekeeping: 'Reinigungsservice',
        airport_transfer: 'Flughafentransfer auf Anfrage',
        baby_cot: 'Babybett auf Anfrage',
        elevator: 'Aufzug'
    },
    home: {
        heroEyebrow: 'Zarzis · Djerba · Tunesien',
        heroTitle: 'Ihr luxuriöser Urlaub in Tunesien',
        heroText: 'Ausgewählte Villen, Ferienhäuser und Ferienwohnungen am Mittelmeer, mit oder ohne privaten Pool. Persönlich betreut von unserem Team in Zarzis.',
        heroPrimary: 'Unterkünfte entdecken',
        heroSecondary: 'Unverbindlich anfragen',
        heroImageAlt: 'Moderne Villa mit Infinity-Pool, Palmen und Blick auf das Mittelmeer',
        aboutImageAlt: 'Weißes tunesisches Haus mit blauer Tür',
        searchTitle: 'Verfügbarkeit anfragen',
        searchDestination: 'Reiseziel',
        searchArrival: 'Anreise',
        searchDeparture: 'Abreise',
        searchGuests: 'Gäste',
        searchButton: 'Anfrage starten',
        anyDestination: 'Alle Reiseziele',
        highlights: [
            { title: 'Vor Ort in Zarzis', text: 'Unser Sitz ist in El Mouensa bei Zarzis, also genau dort, wo Sie Urlaub machen.' },
            { title: 'Sorgfältig ausgewählt', text: 'Villen, Ferienhäuser und Wohnungen in schönen Lagen nahe Strand und Stadt.' },
            { title: 'Unverbindlich anfragen', text: 'Ihre Anfrage ist kostenlos. Verbindlich wird es erst mit unserer Bestätigung.' },
            { title: 'In vier Sprachen', text: 'Website, Kundenkonto und E-Mails auf Deutsch, Französisch, Englisch und Arabisch.' }
        ],
        featuredEyebrow: 'Unsere Unterkünfte',
        featuredTitle: 'Ausgewählte Villen und Ferienwohnungen',
        featuredText: 'Von der Villa mit Infinity-Pool bis zur Ferienwohnung in Strandnähe: Finden Sie die Unterkunft, die zu Ihnen passt.',
        featuredAll: 'Alle Unterkünfte ansehen',
        aboutEyebrow: 'Über uns',
        aboutTitle: 'Zuhause in Zarzis, Gastgeber aus Leidenschaft',
        aboutText1: 'URLAUB DE LUXE TUNESIEN vermittelt hochwertige Ferienvillen, Ferienhäuser und Ferienwohnungen im Süden Tunesiens. Unser Sitz ist in El Mouensa bei Zarzis, nur wenige Minuten von den Stränden des Mittelmeers entfernt.',
        aboutText2: 'Wir beraten Sie persönlich und ehrlich, damit Sie genau die Unterkunft finden, die zu Ihrer Reise passt, und Ihr Urlaub vom ersten Kontakt bis zur Abreise entspannt verläuft.',
        aboutPoints: [
            'Sitz in El Mouensa, 4144 Zarzis',
            'Villen mit und ohne Swimmingpool',
            'Ferienhäuser und Ferienwohnungen',
            'Persönlicher Kontakt per E-Mail und Kundenkonto'
        ],
        categoriesEyebrow: 'Für jeden Anspruch',
        categoriesTitle: 'Finden Sie Ihre Unterkunft',
        categoryPoolTitle: 'Villen mit Pool',
        categoryPoolText: 'Privatsphäre, Sonne und Ihr eigener Swimmingpool.',
        categoryHouseTitle: 'Ferienhäuser',
        categoryHouseText: 'Charmante Häuser mit Innenhof, Garten und viel Ruhe.',
        categoryApartmentTitle: 'Ferienwohnungen',
        categoryApartmentText: 'Komfortable Wohnungen nahe Strand und Stadt.',
        stepsEyebrow: 'So einfach geht es',
        stepsTitle: 'In drei Schritten zum Traumurlaub',
        steps: [
            { title: 'Unterkunft wählen', text: 'Stöbern Sie durch unsere Villen und Ferienwohnungen oder lassen Sie sich von uns beraten.' },
            { title: 'Anfrage senden', text: 'Teilen Sie uns Reisedaten, Personenzahl und Wünsche mit. Ihre Buchungsnummer erhalten Sie sofort.' },
            { title: 'Bestätigung erhalten', text: 'Wir prüfen die Verfügbarkeit und bestätigen Ihre Buchung persönlich per E-Mail.' }
        ],
        destinationsEyebrow: 'Reiseziele',
        destinationsTitle: 'Zarzis und Djerba',
        destinations: [
            { name: 'Zarzis', text: 'Feinsandige Strände, Olivenhaine und eine entspannte Atmosphäre. Zarzis ist der ideale Ort für ruhige Tage am Meer.' },
            { name: 'Djerba', text: 'Die Insel mit weißen Häusern, Palmen und dem lebendigen Markt von Houmt Souk, über den Römerdamm schnell von Zarzis aus erreichbar.' }
        ],
        accountEyebrow: 'Ihr Kundenkonto',
        accountTitle: 'Alles an einem Ort',
        accountText: 'Mit Ihrem persönlichen Kundenkonto behalten Sie Anfragen, Buchungen, Nachrichten und Dokumente jederzeit im Blick.',
        accountPoints: [
            'Status Ihrer Anfragen jederzeit online',
            'Bestätigte und vergangene Buchungen',
            'Reklamationen mit Fotos einreichen',
            'Nachrichten und Dokumente von uns'
        ],
        accountRegister: 'Kostenlos registrieren',
        accountLogin: 'Zum Login',
        ctaTitle: 'Bereit für Sonne, Meer und Erholung?',
        ctaText: 'Senden Sie uns Ihre unverbindliche Anfrage. Wir melden uns so schnell wie möglich persönlich bei Ihnen.',
        ctaButton: 'Jetzt anfragen'
    },
    listing: {
        eyebrow: 'Villen · Häuser · Wohnungen',
        title: 'Unsere Unterkünfte',
        intro: 'Villen mit und ohne Pool, Ferienhäuser und Ferienwohnungen in Zarzis und auf Djerba.',
        filterType: 'Art',
        filterAll: 'Alle',
        filterPool: 'Pool',
        filterPoolAny: 'Egal',
        filterLocation: 'Ort',
        filterLocationAll: 'Alle Orte',
        filterGuests: 'Gäste',
        filterGuestsAny: 'Beliebig',
        filterApply: 'Anzeigen',
        filterReset: 'Zurücksetzen',
        empty: 'Für diese Auswahl haben wir gerade keine passende Unterkunft. Senden Sie uns trotzdem eine Anfrage, wir beraten Sie gern.',
        emptyButton: 'Beratung anfragen'
    },
    detail: {
        back: 'Alle Unterkünfte',
        guests: 'Gäste',
        bedrooms: 'Schlafzimmer',
        bathrooms: 'Badezimmer',
        size: 'Wohnfläche',
        pool: 'Pool',
        poolYes: 'Privat',
        poolNo: 'Nein',
        aboutTitle: 'Über diese Unterkunft',
        amenitiesTitle: 'Ausstattung',
        galleryTitle: 'Impressionen',
        bookingTitle: 'Diese Unterkunft anfragen',
        bookingText: 'Unverbindlich und kostenlos. Ihre Buchungsnummer erhalten Sie sofort.',
        priceNote: 'Der Endpreis hängt von Reisezeit und Personenzahl ab.',
        more: 'Weitere Unterkünfte'
    },
    booking: {
        eyebrow: 'Unverbindlich und kostenlos',
        title: 'Buchungsanfrage',
        intro: 'Teilen Sie uns Ihre Wünsche mit. Ihre Anfrage ist unverbindlich. Erst mit unserer Bestätigung wird die Buchung verbindlich.',
        sectionTravel: 'Ihre Reise',
        sectionGuest: 'Ihre Kontaktdaten',
        sectionWishes: 'Wünsche und Nachricht',
        destination: 'Gewünschtes Reiseziel',
        destinationFlexible: 'Flexibel, bitte beraten Sie mich',
        accommodation: 'Gewünschte Unterkunft',
        accommodationAdvice: 'Noch offen, bitte beraten Sie mich',
        arrival: 'Anreisedatum',
        departure: 'Abreisedatum',
        adults: 'Anzahl der Erwachsenen',
        children: 'Anzahl der Kinder',
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'E-Mail-Adresse',
        phone: 'Telefonnummer',
        nationality: 'Nationalität',
        specialRequests: 'Besondere Wünsche',
        specialRequestsHint: 'Zum Beispiel Babybett, Flughafentransfer oder späte Anreise',
        message: 'Zusätzliche Nachricht',
        privacyBefore: 'Ich habe die ',
        privacyLink: 'Datenschutzerklärung',
        privacyAfter: ' gelesen und bin mit der Verarbeitung meiner Angaben zur Bearbeitung der Anfrage einverstanden.',
        submit: 'Anfrage senden',
        submitting: 'Anfrage wird gesendet …',
        capacityWarning: 'Diese Unterkunft ist für bis zu {count} Gäste ausgelegt. Wir beraten Sie gern zu Alternativen.',
        loggedInAs: 'Sie sind als {name} angemeldet. Die Anfrage erscheint automatisch in Ihrem Kundenkonto.',
        guestHintBefore: 'Tipp: Mit einem ',
        guestHintLink: 'kostenlosen Kundenkonto',
        guestHintAfter: ' sehen Sie den Status Ihrer Anfrage jederzeit online.',
        summary: 'Ihre Auswahl',
        successTitle: 'Vielen Dank für Ihre Anfrage!',
        successText: 'Ihre Anfrage ist bei uns eingegangen. Ihre Buchungsnummer lautet:',
        successEmail: 'Eine Eingangsbestätigung wurde an {email} gesendet. Bitte prüfen Sie auch Ihren Spam-Ordner.',
        successNoEmail: 'Bitte notieren Sie sich Ihre Buchungsnummer. Wir melden uns so schnell wie möglich bei Ihnen.',
        successAccount: 'Zu meinen Anfragen',
        successNew: 'Weitere Anfrage stellen',
        successHome: 'Zur Startseite'
    },
    auth: {
        email: 'E-Mail-Adresse',
        password: 'Passwort',
        showPassword: 'Passwort anzeigen',
        hidePassword: 'Passwort verbergen',
        loginTitle: 'Willkommen zurück',
        loginText: 'Melden Sie sich an, um Ihre Anfragen, Buchungen und Nachrichten zu sehen.',
        forgot: 'Passwort vergessen?',
        loginButton: 'Anmelden',
        loggingIn: 'Anmeldung läuft …',
        noAccount: 'Noch kein Kundenkonto?',
        registerLink: 'Jetzt registrieren',
        notVerifiedAction: 'E-Mail jetzt bestätigen',
        registerTitle: 'Kundenkonto erstellen',
        registerText: 'Registrieren Sie sich kostenlos und verwalten Sie Ihre Anfragen und Buchungen bequem online.',
        firstName: 'Vorname',
        lastName: 'Nachname',
        phone: 'Telefonnummer',
        nationality: 'Nationalität',
        passwordConfirm: 'Passwort bestätigen',
        passwordHint: 'Mindestens 8 Zeichen',
        privacyBefore: 'Ich habe die ',
        privacyLink: 'Datenschutzerklärung',
        privacyAfter: ' gelesen und stimme der Verarbeitung meiner Daten für mein Kundenkonto zu.',
        marketing: 'Ja, ich möchte gelegentlich exklusive Angebote per E-Mail erhalten. Diese Einwilligung kann ich jederzeit widerrufen.',
        registerButton: 'Kundenkonto erstellen',
        registering: 'Konto wird erstellt …',
        haveAccount: 'Bereits registriert?',
        loginLink: 'Zum Login',
        verifyTitle: 'E-Mail-Adresse bestätigen',
        verifyText: 'Wir haben einen 6-stelligen Bestätigungscode an {email} gesendet. Bitte geben Sie ihn hier ein.',
        verifyTextGeneric: 'Geben Sie Ihre E-Mail-Adresse und den 6-stelligen Code aus unserer E-Mail ein.',
        code: 'Bestätigungscode',
        verifyButton: 'E-Mail bestätigen',
        verifying: 'Wird geprüft …',
        resend: 'Neuen Code senden',
        resent: 'Falls ein unbestätigtes Konto zu dieser Adresse existiert, ist ein neuer Code unterwegs. Bitte prüfen Sie auch Ihren Spam-Ordner.',
        verifiedTitle: 'E-Mail-Adresse bestätigt',
        verifiedText: 'Vielen Dank! Ihr Kundenkonto ist jetzt aktiv.',
        emailNotSent: 'Ihr Konto wurde angelegt, aber die Bestätigungs-E-Mail konnte gerade nicht gesendet werden. Bitte fordern Sie unten einen neuen Code an oder versuchen Sie es später erneut.',
        forgotTitle: 'Passwort zurücksetzen',
        forgotText: 'Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Sicherheitscode.',
        sendCode: 'Code senden',
        codeSent: 'Falls ein Kundenkonto mit dieser Adresse existiert, haben wir Ihnen einen Code gesendet. Bitte prüfen Sie auch Ihren Spam-Ordner.',
        resetCode: 'Sicherheitscode',
        newPassword: 'Neues Passwort',
        resetButton: 'Neues Passwort speichern',
        resetDone: 'Ihr Passwort wurde geändert. Sie können sich jetzt anmelden.',
        backToLogin: 'Zurück zum Login',
        sideTitle: 'Ihr Urlaub, persönlich betreut',
        sideText: 'Anfragen, Buchungen, Reklamationen und Nachrichten an einem Ort.'
    },
    errors: {
        required: 'Bitte füllen Sie dieses Feld aus.',
        invalid_email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        invalid_phone: 'Bitte geben Sie eine gültige Telefonnummer ein.',
        invalid_country: 'Bitte wählen Sie eine Nationalität.',
        password_short: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
        password_mismatch: 'Die Passwörter stimmen nicht überein.',
        invalid_date: 'Bitte wählen Sie ein gültiges Datum.',
        date_past: 'Das Datum darf nicht in der Vergangenheit liegen.',
        date_order: 'Die Abreise muss nach der Anreise liegen.',
        stay_too_long: 'Der Aufenthalt darf höchstens 90 Nächte umfassen.',
        invalid_number: 'Bitte geben Sie eine gültige Anzahl ein.',
        consent_required: 'Bitte stimmen Sie der Datenschutzerklärung zu.',
        invalid_credentials: 'E-Mail-Adresse oder Passwort ist nicht korrekt.',
        email_not_verified: 'Bitte bestätigen Sie zuerst Ihre E-Mail-Adresse.',
        account_blocked: 'Dieses Kundenkonto ist gesperrt. Bitte kontaktieren Sie uns.',
        email_taken: 'Diese E-Mail-Adresse ist bereits registriert.',
        code_invalid: 'Der Code ist nicht korrekt.',
        code_expired: 'Der Code ist abgelaufen. Bitte fordern Sie einen neuen an.',
        code_locked: 'Zu viele Fehlversuche. Bitte fordern Sie einen neuen Code an.',
        rate_limited: 'Zu viele Versuche. Bitte warten Sie einen Moment und versuchen Sie es dann erneut.',
        file_type: 'Dieser Dateityp wird nicht unterstützt. Erlaubt sind Bilder, PDF und Word-Dokumente.',
        file_too_large: 'Die Dateien sind zu groß.',
        too_many_files: 'Es sind höchstens 5 Dateien möglich.',
        file_invalid: 'Die Datei konnte nicht gelesen werden.',
        upload_failed: 'Die Dateien konnten nicht hochgeladen werden. Bitte versuchen Sie es erneut.',
        not_cancellable: 'Diese Anfrage beziehungsweise Buchung kann nicht mehr storniert werden.',
        wrong_password: 'Das Passwort ist nicht korrekt.',
        unauthorized: 'Bitte melden Sie sich erneut an.',
        network: 'Keine Verbindung. Bitte prüfen Sie Ihre Internetverbindung.',
        server_error: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
        validation: 'Bitte prüfen Sie Ihre Eingaben.',
        not_found: 'Nicht gefunden.',
        forbidden: 'Diese Aktion ist nicht erlaubt.'
    },
    bookingStatus: {
        new: 'Eingegangen',
        in_review: 'In Bearbeitung',
        confirmed: 'Bestätigt',
        declined: 'Abgelehnt',
        cancelled: 'Storniert',
        completed: 'Abgeschlossen'
    },
    complaintStatus: {
        open: 'Offen',
        in_progress: 'In Bearbeitung',
        resolved: 'Gelöst',
        closed: 'Geschlossen'
    },
    account: {
        areaTitle: 'Mein Kundenkonto',
        customerNumber: 'Kundennummer',
        nav: {
            overview: 'Übersicht',
            profile: 'Mein Profil',
            requests: 'Meine Buchungsanfragen',
            bookings: 'Meine bestätigten Buchungen',
            past: 'Meine vergangenen Buchungen',
            cancellations: 'Meine Stornierungen',
            complaints: 'Meine Reklamationen',
            messages: 'Meine Nachrichten',
            documents: 'Meine Dokumente',
            settings: 'Meine Einstellungen'
        },
        hello: 'Hallo',
        overviewText: 'Hier finden Sie alles rund um Ihre Reisen mit uns.',
        statOpenRequests: 'Offene Anfragen',
        statUpcoming: 'Bevorstehende Reisen',
        statComplaints: 'Offene Reklamationen',
        statMessages: 'Neue Nachrichten',
        nextTrip: 'Ihre nächste Reise',
        noTrip: 'Noch keine bestätigte Reise geplant. Wie wäre es mit Sonne und Meer?',
        newRequest: 'Neue Anfrage',
        recentRequests: 'Ihre letzten Anfragen',
        noRequests: 'Sie haben noch keine Anfragen gestellt.',
        viewAll: 'Alle ansehen',
        profileText: 'Ihre persönlichen Daten. Diese verwenden wir für Ihre Anfragen und Buchungen.',
        emailLocked: 'Die E-Mail-Adresse ist Ihr Login. Für eine Änderung schreiben Sie uns bitte eine Nachricht.',
        profileSaved: 'Ihre Daten wurden gespeichert.',
        memberSince: 'Registriert seit',
        requestsText: 'Anfragen, die wir gerade bearbeiten, sowie abgelehnte Anfragen.',
        bookingsText: 'Ihre bestätigten, bevorstehenden Aufenthalte.',
        pastText: 'Ihre vergangenen Reisen mit uns.',
        cancellationsText: 'Stornierte Anfragen und Buchungen.',
        requestsEmpty: 'Sie haben aktuell keine offenen Anfragen.',
        bookingsEmpty: 'Sie haben aktuell keine bestätigten Buchungen.',
        pastEmpty: 'Hier erscheinen Ihre vergangenen Reisen.',
        cancellationsEmpty: 'Sie haben keine Stornierungen.',
        requestedOn: 'Angefragt am {date}',
        details: 'Details',
        detailTitle: 'Buchung',
        timeline: 'Verlauf',
        submitted: 'Anfrage eingegangen',
        yourDetails: 'Ihre Angaben',
        travelDetails: 'Reisedaten',
        noteFromUs: 'Nachricht von uns',
        totalPrice: 'Gesamtpreis',
        cancelTitle: 'Stornieren',
        cancelText: 'Möchten Sie diese Anfrage beziehungsweise Buchung stornieren? Sie erhalten eine Bestätigung per E-Mail.',
        cancelReason: 'Grund (optional)',
        cancelButton: 'Anfrage oder Buchung stornieren',
        cancelConfirm: 'Ja, jetzt stornieren',
        cancelDone: 'Ihre Stornierung wurde gespeichert.',
        cancelledByCustomer: 'Von Ihnen storniert',
        cancelledByAdmin: 'Von uns storniert',
        reportProblem: 'Problem melden',
        complaintsText: 'Reichen Sie eine Reklamation ein und verfolgen Sie den Bearbeitungsstatus.',
        newComplaint: 'Neue Reklamation',
        complaintsEmpty: 'Sie haben keine Reklamationen.',
        complaintSubject: 'Betreff',
        complaintBooking: 'Betroffene Buchung',
        complaintNoBooking: 'Keine bestimmte Buchung',
        complaintMessage: 'Ihre Nachricht',
        complaintMessageHint: 'Beschreiben Sie bitte möglichst genau, was passiert ist.',
        files: 'Fotos und Dokumente',
        filesHint: 'Bis zu 5 Dateien (Fotos, PDF, Word), zusammen höchstens 10 MB. Große Fotos werden automatisch verkleinert.',
        chooseFiles: 'Dateien auswählen',
        removeFile: 'Datei entfernen',
        complaintSubmit: 'Reklamation einreichen',
        complaintSubmitted: 'Ihre Reklamation {number} wurde eingereicht.',
        complaintNumber: 'Reklamationsnummer',
        submittedOn: 'Eingereicht am',
        attachments: 'Anhänge',
        replyLabel: 'Ihre Antwort',
        replyButton: 'Antwort senden',
        replySent: 'Ihre Antwort wurde gesendet.',
        you: 'Sie',
        closedNote: 'Diese Reklamation ist abgeschlossen. Wenn Sie antworten, öffnen wir sie erneut.',
        messagesText: 'Ihre Nachrichten von und an uns.',
        messagesEmpty: 'Noch keine Nachrichten.',
        newMessage: 'Neue Nachricht schreiben',
        messageSubject: 'Betreff',
        messageBody: 'Nachricht',
        messageSend: 'Nachricht senden',
        messageSent: 'Ihre Nachricht wurde gesendet.',
        fromUs: 'Von uns',
        fromYou: 'Von Ihnen',
        documentsText: 'Dokumente, die wir Ihnen bereitgestellt haben, und Ihre hochgeladenen Dateien.',
        documentsEmpty: 'Noch keine Dokumente vorhanden.',
        uploadedByYou: 'Von Ihnen hochgeladen',
        providedByUs: 'Von uns bereitgestellt',
        languageTitle: 'Sprache für E-Mails',
        languageText: 'In dieser Sprache senden wir Ihnen unsere E-Mails.',
        marketingTitle: 'Angebote per E-Mail',
        marketingText: 'Ich möchte gelegentlich exklusive Angebote per E-Mail erhalten. Diese Einwilligung kann ich jederzeit widerrufen.',
        marketingSince: 'Eingewilligt am {date}',
        passwordTitle: 'Passwort ändern',
        currentPassword: 'Aktuelles Passwort',
        newPassword: 'Neues Passwort',
        confirmPassword: 'Neues Passwort bestätigen',
        passwordSaved: 'Ihr Passwort wurde geändert.',
        privacyTitle: 'Datenschutz',
        privacyAccepted: 'Datenschutzerklärung akzeptiert am {date}',
        deleteTitle: 'Kundenkonto löschen',
        deleteText: 'Ihr Konto, Ihre Reklamationen, Nachrichten und Dokumente werden dauerhaft gelöscht. Buchungsdaten werden anonymisiert. Dies kann nicht rückgängig gemacht werden.',
        deleteButton: 'Kundenkonto löschen',
        deletePassword: 'Bitte geben Sie zur Bestätigung Ihr Passwort ein.',
        deleteFinal: 'Endgültig löschen',
        deleted: 'Ihr Kundenkonto wurde gelöscht.',
        saved: 'Gespeichert.'
    },
    contact: {
        eyebrow: 'Wir sind für Sie da',
        title: 'Kontakt',
        intro: 'Schreiben Sie uns oder senden Sie direkt eine Buchungsanfrage. Wir melden uns so schnell wie möglich persönlich bei Ihnen.',
        email: 'E-Mail',
        address: 'Adresse',
        phone: 'Telefon',
        whatsapp: 'WhatsApp',
        mapLink: 'In Google Maps öffnen',
        bookingTitle: 'Urlaub anfragen',
        bookingText: 'Der schnellste Weg zu Ihrer Unterkunft: Senden Sie uns Reisedaten und Wünsche über das Anfrageformular.',
        bookingButton: 'Zur Buchungsanfrage',
        accountTitle: 'Bereits Kunde?',
        accountText: 'Schreiben Sie uns direkt aus Ihrem Kundenkonto. So haben Sie den gesamten Verlauf immer im Blick.',
        accountButton: 'Nachricht schreiben',
        faqTitle: 'Häufige Fragen',
        faq: [
            { question: 'Ist meine Anfrage verbindlich?', answer: 'Nein. Ihre Anfrage ist kostenlos und unverbindlich. Erst wenn wir Ihre Buchung bestätigen, wird sie verbindlich.' },
            { question: 'Brauche ich ein Kundenkonto?', answer: 'Nein, Sie können auch ohne Konto anfragen. Mit einem Kundenkonto sehen Sie jedoch jederzeit den Status Ihrer Anfragen sowie Ihre Buchungen, Nachrichten und Dokumente.' },
            { question: 'Wie storniere ich eine Anfrage oder Buchung?', answer: 'Melden Sie sich in Ihrem Kundenkonto an und öffnen Sie die Anfrage oder Buchung. Dort können Sie stornieren. Ohne Kundenkonto schreiben Sie uns einfach eine E-Mail mit Ihrer Buchungsnummer.' },
            { question: 'Wie reiche ich eine Reklamation ein?', answer: 'In Ihrem Kundenkonto unter „Meine Reklamationen“. Sie können Fotos und Dokumente anhängen und den Bearbeitungsstatus jederzeit verfolgen.' }
        ]
    },
    footer: {
        about: 'Ferienvillen, Ferienhäuser und Ferienwohnungen in Zarzis und auf Djerba, persönlich betreut aus El Mouensa.',
        explore: 'Entdecken',
        service: 'Service',
        contact: 'Kontakt',
        privacy: 'Datenschutz',
        imprint: 'Impressum',
        rights: 'Alle Rechte vorbehalten.'
    },
    legal: {
        privacyTitle: 'Datenschutzerklärung',
        privacyUpdated: 'Stand: November 2026',
        privacy: [
            { heading: 'Verantwortlicher', body: 'Verantwortlich für die Verarbeitung Ihrer Daten auf dieser Website ist URLAUB DE LUXE TUNESIEN, El Mouensa, 4144 Zarzis, Tunesien. Sie erreichen uns per E-Mail unter urlaub.de.luxe.info@gmail.com.' },
            { heading: 'Welche Daten wir verarbeiten', body: 'Wenn Sie ein Kundenkonto anlegen, speichern wir Vorname, Nachname, E-Mail-Adresse, Telefonnummer und Nationalität. Ihr Passwort speichern wir ausschließlich als sicheren, nicht umkehrbaren Hash. Bei Buchungsanfragen verarbeiten wir zusätzlich Reiseziel, Unterkunft, Reisedaten, Personenzahl sowie Ihre Wünsche und Nachrichten. Bei Reklamationen speichern wir Ihre Beschreibung sowie die Fotos und Dokumente, die Sie hochladen.' },
            { heading: 'Zwecke und Rechtsgrundlagen', body: 'Wir verarbeiten Ihre Daten, um Anfragen zu beantworten, Buchungen durchzuführen, Ihr Kundenkonto bereitzustellen und Reklamationen zu bearbeiten (Art. 6 Abs. 1 lit. b DSGVO). Angebote per E-Mail senden wir nur mit Ihrer ausdrücklichen Einwilligung (Art. 6 Abs. 1 lit. a DSGVO), die Sie jederzeit in Ihrem Kundenkonto widerrufen können. Zum Schutz vor Missbrauch verarbeiten wir technische Daten wie eine pseudonymisierte IP-Kennung (Art. 6 Abs. 1 lit. f DSGVO).' },
            { heading: 'E-Mails', body: 'Bestätigungen und Nachrichten versenden wir über den E-Mail-Dienst unseres Website-Anbieters. Bei HTML-E-Mails wird technisch erfasst, ob eine E-Mail geöffnet und welche Links angeklickt wurden. Diese Angaben nutzen wir nur, um die Zustellung unserer E-Mails sicherzustellen. E-Mail-Adressen, an die E-Mails dauerhaft nicht zugestellt werden können, werden automatisch gesperrt.' },
            { heading: 'Cookies und Besucherstatistik', body: 'Wir setzen nur ein technisch notwendiges Cookie, damit Sie angemeldet bleiben. Werbe- oder Tracking-Cookies verwenden wir nicht. Für die Besucherstatistik nutzen wir ein cookieloses Verfahren, das keine persönlichen Profile erstellt.' },
            { heading: 'Speicherort und Speicherdauer', body: 'Ihre Daten werden bei unserem Hosting-Anbieter gespeichert, Dateien in einem geschützten, nicht öffentlichen Speicher. Wir speichern Ihre Daten, solange Ihr Kundenkonto besteht oder gesetzliche Aufbewahrungspflichten es erfordern. Wenn Sie Ihr Konto löschen, werden Ihre persönlichen Daten, Reklamationen, Nachrichten und Dokumente gelöscht und Buchungsdaten anonymisiert.' },
            { heading: 'Ihre Rechte', body: 'Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch sowie das Recht, eine erteilte Einwilligung jederzeit zu widerrufen. Ihr Kundenkonto können Sie jederzeit selbst unter „Meine Einstellungen“ löschen. Außerdem können Sie sich bei einer Datenschutz-Aufsichtsbehörde beschweren.' },
            { heading: 'Kontakt zum Datenschutz', body: 'Für alle Fragen zum Datenschutz schreiben Sie uns an urlaub.de.luxe.info@gmail.com.' }
        ],
        imprintTitle: 'Impressum',
        imprintProvider: 'Anbieter',
        imprintRepresented: 'Vertreten durch',
        imprintContact: 'Kontakt',
        imprintEmail: 'E-Mail',
        imprintPhone: 'Telefon',
        imprintResponsible: 'Verantwortlich für den Inhalt',
        imprintDisclaimerTitle: 'Haftung für Inhalte',
        imprintDisclaimer: 'Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Verbindlich sind ausschließlich die Angaben in unserer schriftlichen Buchungsbestätigung.'
    },
    notFound: {
        title: 'Seite nicht gefunden',
        text: 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
        button: 'Zur Startseite'
    }
}

export type Dictionary = typeof de
